import { useState } from "react";
import "./Faq.css";

const faqData = [
     {
    question: "Подойдёт ли мне эта профессия?",
    answer:
      "Мы специально сделали бесплатный блок, чтобы вы могли протестировать профессию и принять взвешенное решение. Даже если поймёте, что это не ваше, — вы сэкономите время и сможете двигаться дальше без сомнений."
  },
  {
    question: "Каким требованиям нужно соответствовать?",
    answer:
      "Вам не нужны особые знания или опыт. Мы всё объясним с нуля. Достаточно иметь компьютер и свободное время для учёбы онлайн."
  },
  {
    question: "Какой компьютер нужен для учёбы?",
    answer: 
  "Подойдёт любой современный компьютер на Windows 10 или выше. Минимально нужно: экран от 1280×1024, процессор от 1.8 ГГц, 2 ГБ оперативной памяти, видеокарта с поддержкой OpenGL 4.0 и 1 ГБ свободного места на диске. Для комфортной работы лучше иметь немного более мощный ноутбук или ПК."

  },
  {
    question: "Как проходит обучение?",
   answer: 
  "Обучение строится так: вы получаете доступ к видеоурокам и материалам, выполняете домашние задания и получаете обратную связь от наставника. Дополнительно проходят вебинары в живом формате, где можно глубже разобрать темы. И, конечно, у вас всегда будет возможность задать вопросы наставнику и получить поддержку."

  },
  {
    question: "Будет ли сертификат?",
   answer: 
  "По итогам обучения вы получите именной электронный сертификат. Сертификат не является документом государственного образца, подтверждает прохождение курса и выполненные практические работы."

  },
  {question: "Смогу ли я совмещать учёбу с работой?",
    answer: "Да, сможете. Все материалы доступны онлайн, и вы можете учиться в удобное для вас время. Главное — планировать своё время и выделять регулярные часы для учёбы."
  }
    , {question: "Вы поможете мне найти работу?",
   answer: 
  "Мы не занимаемся прямым трудоустройством — работу предстоит искать самостоятельно. Но мы поможем вам подготовиться: подскажем, как выполнить тестовое задание, и дадим советы по портфолио. А самое важное — даже после трудоустройства вы сможете обращаться к нам с вопросами, если на работе возникнут сложности."

  }
];

function Faq() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAnswer = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq">
      <div className="faq__container">
        <h2 className="faq__title">Частые вопросы</h2>
        <ul className="faq__list">
          {faqData.map((item, index) => (
            <li key={index} className={`faq__item ${activeIndex === index ? "active" : ""}`}>
              <button
                className="faq__question"
                onClick={() => toggleAnswer(index)}
                aria-expanded={activeIndex === index}
              >
                {item.question}
                <span className="faq__icon">{activeIndex === index ? "−" : "+"}</span>
              </button>
              <div className="faq__answer">{item.answer}</div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default Faq;
